import PageTransition from "./Pagetransition";
import Hero from "./Hero";
import { RevealBox, SectionLabel, SectionTitle, Divider } from "./Sectioncomponents";
import { useCounter, useReveal } from "./useReveal";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ProductosPage from "./Productospage";
import UbicacionPage from "./Ubicacionpage";
import ContactoPage from "./Contactpage";

function StatCounter({ target, label }) {
  const { ref, inView } = useReveal();
  const value = useCounter(target, inView, 1200);
  return (
    <div ref={ref} style={{ textAlign: "left" }}>
      <div style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: "3.5rem", fontWeight: 600, lineHeight: 1,
        background: "linear-gradient(135deg, #f0c96b, #c9973a)",
        WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text",
      }}>
        {value}
      </div>
      <div style={{
        fontFamily: "'Jost', sans-serif",
        fontSize: "0.7rem", letterSpacing: "0.2em",
        textTransform: "uppercase", color: "#6b6257", marginTop: "0.3rem",
      }}>
        {label}
      </div>
    </div>
  );
}

function WindowSVG() {
  return (
    <svg viewBox="0 0 400 400" fill="none" style={{ width: "100%", height: "100%" }}>
      <defs>
        <linearGradient id="alum1h" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#c9973a" stopOpacity="0.9"/>
          <stop offset="50%" stopColor="#f0c96b" stopOpacity="1"/>
          <stop offset="100%" stopColor="#8b6220" stopOpacity="0.8"/>
        </linearGradient>
        <linearGradient id="glass1h" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#a8d8ea" stopOpacity="0.25"/>
          <stop offset="100%" stopColor="#e8f4f8" stopOpacity="0.1"/>
        </linearGradient>
        <linearGradient id="alum2h" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#8b6220"/>
          <stop offset="50%" stopColor="#c9973a"/>
          <stop offset="100%" stopColor="#f0c96b"/>
        </linearGradient>
      </defs>
      <rect x="30" y="30" width="340" height="290" rx="3" fill="url(#alum1h)" opacity="0.9"/>
      <rect x="40" y="40" width="320" height="270" rx="2" fill="#1a1814"/>
      <rect x="45" y="45" width="150" height="260" rx="1" fill="url(#glass1h)"/>
      <rect x="205" y="45" width="150" height="260" rx="1" fill="url(#glass1h)"/>
      <rect x="193" y="40" width="14" height="270" fill="url(#alum2h)"/>
      <rect x="45" y="160" width="150" height="8" fill="url(#alum2h)"/>
      <rect x="205" y="160" width="150" height="8" fill="url(#alum2h)"/>
      <circle cx="188" cy="175" r="5" fill="#c9973a"/>
      <rect x="184" y="170" width="8" height="20" rx="4" fill="url(#alum1h)"/>
      <circle cx="212" cy="175" r="5" fill="#c9973a"/>
      <rect x="208" y="170" width="8" height="20" rx="4" fill="url(#alum1h)"/>
      <line x1="60" y1="50" x2="100" y2="160" stroke="rgba(255,255,255,0.04)" strokeWidth="20"/>
      <line x1="220" y1="50" x2="260" y2="165" stroke="rgba(255,255,255,0.04)" strokeWidth="20"/>
      <rect x="20" y="320" width="360" height="22" rx="2" fill="url(#alum1h)"/>
      <rect x="20" y="30" width="14" height="312" rx="2" fill="url(#alum1h)"/>
      <rect x="366" y="30" width="14" height="312" rx="2" fill="url(#alum1h)"/>
      <text x="200" y="375" textAnchor="middle" fill="rgba(201,151,58,0.7)"
        fontFamily="Cormorant Garamond, serif" fontSize="14" letterSpacing="4" fontStyle="italic">
        Línea Modena
      </text>
      <text x="60" y="375" textAnchor="middle" fill="rgba(201,151,58,0.35)" fontSize="10">◆</text>
      <text x="340" y="375" textAnchor="middle" fill="rgba(201,151,58,0.35)" fontSize="10">◆</text>
    </svg>
  );
}

export default function HomePage() {
  return (
    <PageTransition>
      <Hero />

      <section style={{
        padding: "7rem 0", position: "relative", overflow: "hidden",
        background: "linear-gradient(180deg, #1a1814 0%, #151210 100%)",
      }}>
        <span style={{
          position: "absolute", right: "-2rem", top: "50%",
          transform: "translateY(-50%) rotate(90deg)",
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "12rem", fontWeight: 700,
          color: "rgba(201,151,58,0.03)",
          whiteSpace: "nowrap", pointerEvents: "none",
          letterSpacing: "0.2em", userSelect: "none",
        }}>MONACO</span>

        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 2rem" }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "5rem", alignItems: "center",
          }}>
            <div>
              <RevealBox><SectionLabel>Nuestra Historia</SectionLabel></RevealBox>
              <RevealBox delay={0.1}>
                <SectionTitle>
                  Calidad que <em>transforma</em><br/>cada espacio
                </SectionTitle>
              </RevealBox>
              <RevealBox delay={0.2}><Divider /></RevealBox>
              <RevealBox delay={0.25}>
                <p style={{ fontFamily: "'Jost', sans-serif", fontSize: "1.05rem", fontWeight: 300, lineHeight: 1.9, color: "rgba(249,245,239,0.75)", marginBottom: "1.2rem" }}>
                  En Monaco Aberturas nos especializamos en la fabricación e instalación de aberturas de aluminio de alta gama. Cada proyecto tratado con el mismo compromiso de excelencia y atención al detalle que nos define.
                </p>
                <p style={{ fontFamily: "'Jost', sans-serif", fontSize: "1.05rem", fontWeight: 300, lineHeight: 1.9, color: "rgba(249,245,239,0.75)", marginBottom: "3rem" }}>
                  Trabajamos con los mejores perfiles del mercado para garantizar durabilidad, hermeticidad y una estética impecable que eleva el valor de cualquier propiedad.
                </p>
              </RevealBox>

              <div style={{ display: "flex", gap: "3rem", flexWrap: "wrap" }}>
                <StatCounter target={10}  label="+ Años de experiencia" />
                <StatCounter target={500} label="+ Proyectos realizados" />
                <StatCounter target={100} label="% Garantía de calidad" />
              </div>

              <div style={{ marginTop: "2.5rem" }}>
                <Link to="/productos" style={{ textDecoration: "none" }}>
                  <motion.span
                    whileHover={{ y: -2, boxShadow: "0 12px 40px rgba(201,151,58,0.4)" }}
                    whileTap={{ scale: 0.97 }}
                    style={{
                      display: "inline-block", padding: "1rem 2.5rem",
                      background: "linear-gradient(135deg, #8b6220, #c9973a, #f0c96b)",
                      color: "#1a1814", fontFamily: "'Jost', sans-serif",
                      fontSize: "0.8rem", fontWeight: 600,
                      letterSpacing: "0.25em", textTransform: "uppercase", cursor: "none",
                    }}
                  >
                    Ver productos
                  </motion.span>
                </Link>
              </div>
            </div>

            <RevealBox delay={0.15}>
              <div style={{
                position: "relative",
                background: "linear-gradient(135deg, #1e1a14, #252015)",
                border: "1px solid rgba(201,151,58,0.15)",
                padding: "3rem", overflow: "hidden",
              }}>
                <div style={{
                  position: "absolute", top: 0, left: 0, right: 0, height: 2,
                  background: "linear-gradient(to right, transparent, #c9973a, transparent)",
                }} />
                <WindowSVG />
              </div>
            </RevealBox>
          </div>
        </div>
      </section>
      <ProductosPage/>
      <UbicacionPage/>
      <ContactoPage/>
    </PageTransition>
  );
}